<template>
  <div class="base-content-block">
    <section class="migration-cta">
      <div class="migration-cta__wrapper">
        <div class="migration-cta__content">
          <h3 class="migration-cta__title typography__headline3">
            {{ t("rates.migrationTitle") }}
          </h3>
          <ul class="migration-cta__list">
            <li class="migration-cta__item typography__body1">
              <BaseIcon2
                id="icon-check"
                class="migration-cta__icon"
              />
              {{ t("rates.migrationAudit") }}
            </li>
            <li class="migration-cta__item typography__body1">
              <BaseIcon2
                id="icon-check"
                class="migration-cta__icon"
              />
              {{ t("rates.migrationHelp") }}
            </li>
            <li class="migration-cta__item typography__body1">
              <BaseIcon2
                id="icon-check"
                class="migration-cta__icon"
              />
              {{ t("rates.migrationConsultation") }}
            </li>
          </ul>
        </div>
        <BaseModalButton
          class="base-button-extra-big migration-cta__button main-base-button-first typography__title2"
          :modal="MODAL.ContactMigration"
        >
          {{ t("rates.migrationButton") }}
        </BaseModalButton>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped>
.migration-cta {
  width: 100%;
  padding: 32px 24px;
  background-color: var(--grey-7);
  border-radius: 12px;
}

@media (--desktop) {
  .migration-cta {
    padding: 48px 64px;
  }
}

.migration-cta__wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (--desktop) {
  .migration-cta__wrapper {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.migration-cta__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.migration-cta__title {
  color: var(--grey-1);
}

.migration-cta__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.migration-cta__item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--grey-1-5);
}

.migration-cta__icon {
  width: 20px;
  height: 20px;
  color: var(--green);
}

.migration-cta__button {
  border-radius: 30px;
  white-space: nowrap;
}
</style>
